import React, { useEffect, useState } from "react";
import WorkshopB2BDataService from "../../services/WorkshopB2B";
import { WorkshopB2BExpertPriceList } from "./WorkshopB2BExpertPriceList";
import { useLocation } from "react-router-dom";

export const WorkshopB2BExpertList = () => {

  const location = useLocation();
  const monthyearData = location.state;
  
  const [list, setList] = useState<any>([]);
  const [filterList, setFilterList] = useState<any>([]);
  const [year, setYear] = useState(monthyearData.year);
  const [month, setMonth] = useState(monthyearData.month);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    WorkshopB2BDataService.getAllFilteredB2BWorkshop(year, month)
      .then((res: any) => {
        setList(res.data.data);
        setFilterList(res.data.data);
        setIsLoading(false);
      })
      .catch((error: any) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const generateMonths = () => {
    const currentMonth = new Date().getMonth() + 1;

    return Array.from({ length: currentMonth }, (_, i) => {
      const monthNumber = (i + 1).toString().padStart(2, "0");
      const monthName = new Date(`2025-${monthNumber}-01`).toLocaleString(
        "en-US",
        { month: "long" }
      );

      return { name: monthName, value: monthNumber };
    });
  };

  const months = generateMonths();

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">
        B2B Workshops - Monthly Expert Billing
      </div>
      <div className="p-4">
        <div className="d-flex gap-6">
          <div className="input-group col-md-3">
            <select
              className="form-control filter-sec"
              id="year"
              value={year}
              onChange={(e) => {
                setYear(e.target.value);
              }}
            >
              <option value="">Select Year</option>
              <option value="2025">2025</option>
            </select>
          </div>
          <div className="input-group col-md-3">
            <select
              className="form-control filter-sec"
              id="month"
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
              }}
            >
              <option value="">Select Month</option>
              {months.map((month) => (
                <option key={month.value} value={month.value}>
                  {month.name}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="nested p-lg-0"> */}
          <div className="input-group col-md-2">
            <button
              className="btn action-btn search-btn"
              type="button"
              onClick={fetchData}
            >
              Search
            </button>
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className="container expert-pricing-div">
        <div className="row justify-content-start">
          {filterList && filterList.length > 0 ? (
            filterList.map((el: any) => (
              <div
                key={el._id}
                className="col-md-3 col-sm-6 mb-2"
                style={{ paddingLeft: "5px", paddingRight: "5px" }}
              >
                <WorkshopB2BExpertPriceList
                  key={el._id}
                  data={el}
                  total_price={el.total_price}
                  func={fetchData}
                  month={month}
                  year={year}
                />
              </div>
            ))
          ) : (
            <h1 className="no-data">No Data Found</h1>
          )}
        </div>
      </div>
    </div>
  );
};
